import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

const WHY_ITEMS = [
  { icon: 'ri-lightbulb-flash-line', key: 'why1' },
  { icon: 'ri-meta-line', key: 'why2' },
  { icon: 'ri-robot-2-line', key: 'why3' },
  { icon: 'ri-speed-up-line', key: 'why4' },
  { icon: 'ri-pie-chart-2-line', key: 'why5' },
  { icon: 'ri-refresh-line', key: 'why6' },
];

export default function WhyChooseUs() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-4">
              {t('trafficPro.whyTag')}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
              {t('trafficPro.whyTitle')}{' '}
              <span className="text-primary-500">{t('trafficPro.whyTitleHighlight')}</span>
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY_ITEMS.map((item, i) => (
            <ScrollReveal key={item.key} delay={i * 0.07}>
              <div className="group bg-white border border-gray-100 rounded-2xl p-7 hover:border-primary-200 hover:shadow-[0_8px_32px_rgba(0,0,0,0.05)] hover:-translate-y-1 transition-all duration-400">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                    <i className={`${item.icon} text-primary-500 text-xl group-hover:text-white transition-colors duration-300`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                      {t(`trafficPro.${item.key}Title`)}
                    </h3>
                    <p className="text-foreground-600 text-sm leading-relaxed">
                      {t(`trafficPro.${item.key}Desc`)}
                    </p>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}